export default __webpack_public_path__ + "static/media/happy.3e1a9090.mp3";